import { render } from "./Summary.vue?vue&type=template&id=58b7d7f1"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
script.render = render

export default script